import React, { useState } from 'react'

import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Table,
  Tabs,
  Tag,
  message
} from 'antd'

import HeroModal from './components/HeroModal'
import HeroLocations from './components/HeroLocations'
import HeroDocument from './components/HeroDocument'
import { HeroType } from '../../config'
import {
  deleteHero,
  getHeroLocationList,
  getAllHeroes,
  getHeroConfigs,
  saveQrCodeHero
} from '../../modules/hero'
import { fetchDocumentPendingByHeroId } from '../../modules/document'
import { updateCoinAllHero  } from '../../modules/coin'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { HERO_TYPE, STATUS } from '../../utils/constants'
import { useDeepEffect } from '../../utils/hooks'
import QrCodeModal from './components/QrCodeModal'
import UpdateCoinAllHero from './components/UpdateCoinAllHero'
import moment from 'moment';
import Lightbox from "react-image-lightbox";
import "../../../node_modules/react-image-lightbox/style.css";
import axios from 'axios'

const GetStatusColor = (status) => {
  let color = ''
  if (status !== null) {
    switch (status.toUpperCase()) {
      case 'REGISTERED':
        color = 'gold'
        break
      case 'PENDING':
        color = 'cyan'
        break
      case 'APPROVED':
        color = 'green'
        break
      case 'SUSPENDED':
        color = 'red'
        break
      case 'DISABLED':
        color = 'volcano'
        break
      case 'DELETED':
        color = 'purple'
        break
      default:
        break
    }
  }
  return color
}

const initialOptions = {
  page: 0,
  size: 20,
  heroType: '',
  status: ''
}

const Heroes = ({ form }) => {
  const { validateFields, getFieldDecorator } = form
  const dispatch = useDispatch()
  const [qrCode, setQrCode] = useState({})
  const [formData, setFormData] = useState({})
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [visible, setVisible] = useState(false)
  const [visibleQR, setVisibleQR] = useState(false)
  const [visibleCoin, setVisibleCoin] = useState(false)
  const [filterOption, setFilterOption] = useState(initialOptions)
  const [current, setCurrent] = useState('')

  const { locationList, heroList, heroConfigList, heroDocumentPending ,isLoading } = useSelector(
    (state) => ({
      locationList: state.hero.locationList,
      heroList: state.hero.heroList,
      heroConfigList: state.hero.heroConfigList,
      heroDocumentPending: state.document.heroDocumentPending,
      isLoading : state.coin.isLoading
    }),
    []
  )

  async function fetch() {
    await dispatch(getHeroConfigs())
    await dispatch(getHeroLocationList())
    await dispatch(getAllHeroes(filterOption))
    await dispatch(fetchDocumentPendingByHeroId())
  }

  useDeepEffect(() => {
    fetch()
  }, [])

  async function onOk() {
    await dispatch(getAllHeroes(filterOption))
    await setVisible(false)
  }

  async function onClose() {
    await setFormData({})
    await setVisible(false)
  }

  async function onDelete(id) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    const res = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/hero/hero/${id}`, {
      headers: {
        Authorization: authorizationHeader
      }
    })
    if (!res.data.delete) {
      message.error(res.data.message)
    } else {
      await dispatch(getAllHeroes(filterOption))
      message.success(res.data.message)
    }
  }

  async function onClick(e, record) {
    e.preventDefault()
    await setFormData(record)
    await setVisible(true)
  }

  async function viewQrCode(e, record) {
    e.preventDefault()
    await setQrCode(record)
    await setVisibleQR(true)
  }

  async function onCloseViewQr(e) {
    e.preventDefault()
    await setQrCode({})
    await setVisibleQR(false)
  }

  const onClickCoin = () => {
    setVisibleCoin(true)
  }

  const onCloseModalCoin = async () => {
    await setVisibleCoin(false)
    await fetch()
  }

  const onOkCoin = async (data) => {
    await dispatch(updateCoinAllHero(data))
    await setVisibleCoin(false)
    await fetch()
  }

  async function saveQrCode() {
    if (!isEmpty(selectedRowKeys)) {
      const arr = []
      for (const id of selectedRowKeys) {
        for (const hero of heroList.content) {
          if (hero.qrCode === null) {
            if (hero.id === id) {
              arr.push(id)
            }
          }
        }
      }

      await dispatch(
        saveQrCodeHero({
          heroIds: arr
        })
      )
      await dispatch(getAllHeroes(filterOption))
    } else {
      notification.warning({
        message: 'เลือกฮีโร่อย่างน้อย 1 ฮีโร่'
      })
    }
  }

  const handleClickImage = (e, image) => {
    e && e.preventDefault();
    setCurrent(image)
  };

  const handleCloseModal = e => {
    e && e.preventDefault();
    setCurrent('')
  };

  const renderIdPending = (id) => {
    let status = ''
    for (const hero of heroDocumentPending) {
      if (id === hero.heroId) {
        status = 'PENDING'
      }
    }
    return status
  }
  const GetDate = (created) => {
    let date = ''
    if (created !== null) {
      date = moment(created).add(543, 'years').format('DD/MM/YYYY')
    }
    return date
  }

  const columns = [
    {
      title: 'วันที่สมัคร',
      dataIndex: 'heroDtoList.createdAt',
      key: 'createdAt',
      render: (createdAt) => {
        const created = GetDate(createdAt)
        return (
          <span>
            {created}
          </span>
        )
      }
    },
    {
      title: 'Avatar',
      dataIndex: 'heroDtoList.imageUrl',
      key: 'imageUrl',
      width: 80,
      render: (text, record) => (
        <div>
          <Avatar src={text} onClick={e => handleClickImage(e, text)} />
          {current && (
            <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
          )}
        </div>
      )
    },
    {
      title: 'Email',
      dataIndex: 'heroDtoList.email',
      key: 'email'
    },
    {
      title: 'Hero Type',
      dataIndex: 'heroDtoList.heroType',
      key: 'heroType',
      render: (name, row) => {
        return <div>{HeroType[name] ? HeroType[name].title : '-'}</div>
      }
    },
    {
      title: 'Circular Hero Name',
      dataIndex: 'heroDtoList.name',
      key: 'name'
    },
    {
      title: 'Province',
      dataIndex: 'heroDtoList.province',
      key: 'province'
    },
    {
      title: 'Telephone',
      dataIndex: 'heroDtoList.tel',
      key: 'telephone'
    },
    {
      title: 'Status',
      dataIndex: 'heroDtoList.status',
      key: 'status',
      filters: STATUS.map((status) => ({
        text: status,
        value: status
      })),
      onFilter: (value, record) => record.heroDtoList.status === value,
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'QR Code',
      dataIndex: 'heroDtoList.qrCode',
      key: 'qrCode',
      render: (text, record) => (
        <a onClick={(e) => viewQrCode(e, record)}>View</a>
      )
    },
    {
      title: 'คู่ค้า',
      dataIndex: 'countFollowingHero',
      key: 'FollowingHero'
    },
    {
      title: 'ลูกค้า',
      dataIndex: 'countFollowerHero',
      key: 'FollowerHero'
    },
    {
      title: 'Document Status',
      dataIndex: 'heroDtoList.id',
      key: 'id',
      filters: [
        {
          text: "PENDING",
          value: "PENDING"
        }
      ],
      onFilter: (value, record) => {
        const status = renderIdPending(record.heroDtoList.id)
        return status === value
      },
      render: (id) => {
        const status = renderIdPending(id)
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => onClick(e, record.heroDtoList)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.heroDtoList.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  async function onShowSizeChange(current, pageSize) {
    filterOption.size = pageSize
    setFilterOption(filterOption)
    await dispatch(getAllHeroes(filterOption))
  }

  async function onChange(page) {
    filterOption.page = page - 1
    setFilterOption(filterOption)
    await dispatch(getAllHeroes(filterOption))
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        if (values.heroType === 'all') {
          filterOption.heroType = ''
        } else {
          filterOption.heroType = values.heroType
        }

        if (values.status === 'all') {
          filterOption.status = ''
        } else {
          filterOption.status = values.status
        }

        if (values.keyword) {
          filterOption.keyword = '%' + values.keyword + '%'
        } else {
          filterOption.keyword = ''
        }

        filterOption.page = 0
        await dispatch(getAllHeroes(filterOption))
      }
    })
  }

  async function onClear() {
    filterOption.page = initialOptions.page
    filterOption.size = initialOptions.size
    filterOption.heroType = ''
    filterOption.status = ''
    filterOption.keyword = ''
    form.resetFields()
    await dispatch(getAllHeroes(filterOption))
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys)
    },
    selectedRowKeys: selectedRowKeys
  }

  return (
    <Card
      title="Heroes"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={() => onClickCoin()}>
            Coin
          </Button>
          <Button size="small" icon="plus" onClick={() => setVisible(true)}>
            New Hero
          </Button>
          <Button size="small" icon="reload" onClick={() => fetch()}>
            Reload
          </Button>
        </div>
      }>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Heroes Manager" key="1">
          <Form onSubmit={onSubmit} layout="inline">
            <Row type="flex" justify="space-between" align="middle">
              <Col>
                <Button type="primary" onClick={() => saveQrCode()}>
                  Save QR Code
                </Button>
              </Col>
              <Col>
                <Row type="flex" justify="end" gutter={8} align="middle">
                  <Col>
                    <Form.Item style={{ margin: 0 }}>
                      {getFieldDecorator(`keyword`)(
                        <Input
                          style={{ width: 200 }}
                          placeholder="Email,Name,Tel,Province"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item style={{ margin: 0 }} label="สถานะ">
                      {getFieldDecorator(`status`, {
                        initialValue: 'all'
                      })(
                        <Select style={{ width: 150 }}>
                          <Select.Option value="all">ทั้งหมด</Select.Option>
                          {STATUS.map((type) => {
                            return (
                              <Select.Option key={type} value={type}>
                                {type}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item style={{ margin: 0 }} label="ประเภทฮีโร่">
                      {getFieldDecorator(`heroType`, {
                        initialValue: 'all'
                      })(
                        <Select style={{ width: 150 }}>
                          <Select.Option value="all">ทั้งหมด</Select.Option>
                          {HERO_TYPE.map((type) => {
                            return (
                              <Select.Option key={type} value={type}>
                                {type}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col>
                    <Button type="primary" htmlType="submit">
                      ค้นหา
                    </Button>
                  </Col>
                  <Col>
                    <Button type="danger" onClick={() => onClear()}>
                      เคลียร์
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
          {!isEmpty(heroList) && (
            <Table
              // rowSelection={rowSelection}
              bordered
              loading={isLoading}
              scroll={{ x: 1555 }}
              rowKey={(record) => record.id}
              dataSource={heroList.content}
              columns={columns}
              pagination={{
                current: heroList.pageable.pageNumber + 1,
                pageSize: heroList.size,
                pageSizeOptions: ['10', '20', '50', '100'],
                showSizeChanger: true,
                onShowSizeChange: onShowSizeChange,
                onChange: onChange,
                total: heroList.totalElements
              }}
            />
          )}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Heroes Map" key="2">
          <HeroLocations locations={locationList} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Document Pending" key="3">
          <HeroDocument />
        </Tabs.TabPane>
      </Tabs>
      <UpdateCoinAllHero
        visibleCoin={visibleCoin}
        onCloseModalCoin={onCloseModalCoin}
        onOkCoin={onOkCoin}
      />
      <QrCodeModal
        visible={visibleQR}
        onClose={onCloseViewQr}
        qrCodeData={qrCode}
      />
      <HeroModal
        heroConfigs={heroConfigList}
        visible={visible}
        onClose={onClose}
        onOk={onOk}
        formData={formData}
        statusOptions={STATUS}
        heroTypeOptions={HERO_TYPE}
      />
    </Card>
  )
}

const WrappedHeroes = Form.create({ name: 'Heroes' })(Heroes)
export default WrappedHeroes



// WEBPACK FOOTER //
// ./src/pages/Heroes/index.js